<br><br>
<div class="container" style="padding-top: 80px;">
  
  <app-breadcrumb [data]="product"></app-breadcrumb>
</div>
<br />

<div class="row ">
  <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12  ">
    <div class="preview hide-me" *ngFor="let imgf of product.images">
      <div  class="col-lg-12 col-xs-6 col-sm-6 col-md-6 col-sm-6 col-xs-12">
        <img (click)="setImage(imgf)" src={{imgf}} alt="" class="{{imgf === currentimage ? '' :'border'}}" 
        style="height: 100px; width: 100px; object-fit: cover; border: solid 1.5px black;"/>
      </div>
      <br />
    </div>
  </div>
  <div class="col-lg-9">
    <div class="container">
      <div class="row">
        <div class="col-lg-5 col-md-12" style="margin-bottom: 16px;">
          <img src={{currentimage}} alt="" />
        </div>
        <div class="col-lg-1 col-md-12  hide-me-1" style="border:none; overflow-x: scroll; overflow-y: hidden; padding:20px; display:flex; width: 3000px;">
          <div class="row" style="margin-right: 12px;" *ngFor="let imgf of product.images">
          <div >
            <img (click)="setImage(imgf)" id="hide-me-1" src={{imgf}} alt="" class="{{imgf === currentimage ? '' :'border'}}" 
            style="  height: 100px; width: 100px; object-fit: cover; border: solid 1.5px black;"/>
          </div>
          </div>
        </div>
        <div class="col-lg-4 col-md-12">
          <h5 style="font-size: 24px;">{{product.name}}</h5>
          <b>Rs.{{price}}</b><a>/inc.tax</a>
          <br />
          <br />
          <br />
          <p class="float-left">Available Size:</p>
          <p class="size float-right">Size chart</p>
          <br />
          <div class="available_size btn-block" >
          <b *ngFor="let s of product.avail" class="available_size">{{s}}</b>
          </div>
          <br />
          <section id="d_size" class="d_size">
            <form>
              <div class="d_size-1">
                

                <div class="select btn-block" style="height: 47px;" tabindex="1">
                  <select class="custom-select" (change)="setSize($event.target!!.value)">
                    <option value=''> Select Size</option>
                    <option  *ngFor="let s of product.size | keyvalue" [value]="s.key" >{{s.key}}</option>
                </select>
                  <!-- <input class="selectopt" name="test" type="radio" id="opt1" checked/>
                  <label for="opt1" class="option">Select Size</label>
                  
                  <input *ngFor="let s of product.size | keyvalue" class="selectopt" name="test" type="radio" id={{s.key.toLowerCase()}} />
                  <label *ngFor="let s of product.size | keyvalue" for={{s.key.toLowerCase()}} class="option">{{s.key}}</label> -->
                </div>
              </div>
            </form>
          </section>
          <br />
          <button (click)="addToCart()" class="button btn-block btn" >Add to Cart</button>

          <br>
          <b style="font-size: 22px; margin-bottom: 100px;">Description</b>
          <br>
          <div style="margin-left: 16px;">
            <div style="height: 16px;"></div>
          <div style="margin-top: 8px; margin-bottom: 8px;"  *ngFor="let s of product.description | keyvalue">
            <small style="width: 100px; font-size: 14px;" class="float-left l-1">{{s.key}}:</small>
          <small class="text-muted" style="font-size: 12px;"
            >{{s.value}}</small
          ><br />
          </div>
          <div style="height: 16px;"></div>
          <div class="info">
            <a href="#">More information</a>
          </div>
          <br />
          <div class="row">
            <div class="col-lg-6">
              <img src="../../assets/images/svg/deliver.svg" style="width: 24px;"/>
              <br>
              <b style="font-size:14px; margin-top: 16px;">Order Today, Delivers:</b><br>
              <small class="text-muted">{{deliverytime}} Business Days - {{deliveryfee}}</small>
            </div>
            <div class="col-lg-6">
              <img src="../../assets/images/svg/lock.svg" style="height: 24px; width: 24px;"/>

              <br>
              <b style="font-size:14px; margin-top: 16px;">Only in India</b><br>
              <small class="text-muted">Return and exchanges with {{returntime}} days</small>
            </div>
          </div>
          <br />
          <p><b>Delivery / Return +</b></p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<br><br><br>
<section class="bestproduct"  id="bestproduct">
  <div class="container">
    <h6 style="font-size: 16px;">You may also like</h6>
    <div class="row">
          <div class="col-md-6 col-lg-3" style="padding: 0px;" id="product"  *ngFor="let product of liked">
            <app-productitem [data]="product"
            ></app-productitem>
          </div>
        </div>
  </div>
</section>